import type {
  GetMeAdditionalDocumentDTO,
  GetMeInsuranceCardDTO,
  GetMePatientDTO,
  GetMePaymentMethodDTO,
  GetMeResponseDTO,
} from "apiClients/apiPatient";

export type MePatient = GetMePatientDTO;
export type MeInsuranceCard = GetMeInsuranceCardDTO;
export type MePaymentMethod = GetMePaymentMethodDTO;
export type MeAdditionalDocument = GetMeAdditionalDocumentDTO;

// insuranceCard は orval が allOf + nullable を正しく推論できないため refinement
export type Me = Omit<GetMeResponseDTO, "insuranceCard"> & {
  insuranceCard: MeInsuranceCard | null;
};

export function toMe(dto: GetMeResponseDTO): Me {
  return {
    ...dto,
    insuranceCard: (dto.insuranceCard as MeInsuranceCard | null) ?? null,
  };
}
